module.exports = __webpack_public_path__ + "images/logo-dark-not-transparent-99f2e410c97e074e34e7eabf1c38232d.png";